module.exports = __webpack_public_path__ + "img/3-(10).b1191968.jpg";